import { useState, useEffect } from "react";

export const usePersistentFilters = (storageKey, defaultFilters) => {
    const savedFilters = JSON.parse(localStorage.getItem(storageKey));
    const [filters, setFilters] = useState(savedFilters || defaultFilters);

    useEffect(() => {
        localStorage.setItem(storageKey, JSON.stringify(filters));
    }, [filters, storageKey]);

    const resetFilters = () => {
        setFilters(defaultFilters);
        localStorage.removeItem(storageKey);
    };

    return [filters, setFilters, resetFilters];
};

export default usePersistentFilters;
